import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useCallback } from 'react';
import { isArray } from 'lodash';
import { Dropdown } from '@rexlabs/select';

function RexLabsSelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      items = _ref.items,
      props = _objectWithoutProperties(_ref, ["value", "onChange", "items"]);

  // HACK: the forms API expects flat values when you submit the form,
  // the select however is now built to return the whole value/label
  // object, so we deal with that manually here :/
  var selectValue = isArray(value) ? items === null || items === void 0 ? void 0 : _filterInstanceProperty(items).call(items, function (item) {
    return _includesInstanceProperty(value).call(value, item.value);
  }) : items === null || items === void 0 ? void 0 : _findInstanceProperty(items).call(items, function (item) {
    return (item === null || item === void 0 ? void 0 : item.value) === value;
  });
  var handleChange = useCallback(function (e) {
    var _e$target, _e$target$value;

    onChange({
      target: {
        value: (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$value = _e$target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.value
      }
    });
  }, [onChange]);
  return /*#__PURE__*/React.createElement(Dropdown, _extends({}, props, {
    items: items,
    value: selectValue,
    onChange: handleChange
  }));
}

export default RexLabsSelect;